export default [
  // Home
  {
    name: '',
    path: '/Home',
    component: () => import('@/views/home/Home'),
  },
]
